module.exports = __webpack_public_path__ + "img/dllogo2.bb422d5f.png";